import { Root as ImageRoot } from '../Image/styles';
import { iconDisabledStyles, iconHoverFocusStyles, iconIdlePrimaryStyles } from '../Icon/styles';
import { css } from '@linaria/core';
import media from '../primitives/Media';
export const localVars = {
    '--local-loader-border-idle': '3px',
};
export const Loader = {
    base: css `
		${localVars};
		position: absolute;
		top: 50%;
		left: 50%;

		box-sizing: border-box;
		width: 30px;
		height: 30px;
		margin-top: -15px;
		margin-left: -15px;
		border: var(--button-primary-border-idle) solid transparent;
		border-top: var(--local-loader-border-idle) solid rgb(var(--button-primary-color-label-idle));
		border-radius: var(--button-primary-corner-radius-all);

		animation: spin 600ms linear infinite;

		@keyframes spin {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	`,
    type: {
        primary: css `
			/* Focus */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-primary-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-primary-color-label-focus));
				}
			}

			/* Hover */
			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-primary-color-label-hover));
				}
			}

			/* Pressed */
			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-primary-color-label-pressed));
			}
		`,
        secondary: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-secondary-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-secondary-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-secondary-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-secondary-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-secondary-color-label-pressed));
			}
		`,
        square: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-square-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-square-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-square-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-square-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-square-color-label-pressed));
			}
		`,
        text: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-text-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-text-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-text-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-text-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-text-color-label-pressed));
			}
		`,
        chip: css `
			width: 20px;
			height: 20px;
			margin-top: -10px;
			margin-left: -10px;
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-chip-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-chip-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-chip-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-chip-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-chip-color-label-pressed));
			}
		`,
        tab: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-tab-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-tab-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-tab-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-tab-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-tab-color-label-pressed));
			}
		`,
        live: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-live-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-live-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-live-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-live-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-live-color-label-pressed));
			}
		`,
        function: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-function-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-function-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-function-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-function-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-function-color-label-pressed));
			}
		`,
        mini: css `
			width: 20px;
			height: 20px;
			margin-top: -10px;
			margin-left: -10px;
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-mini-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-mini-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-mini-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-mini-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-mini-color-label-pressed));
			}
		`,
        textExt: css `
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedText-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedText-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedText-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedText-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedText-color-label-pressed));
			}
		`,
        squareExt: css `
			width: 40px;
			height: 40px;
			margin-top: -20px;
			margin-left: -20px;
			border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedSquare-color-label-idle));

			/* Hover / Focus / Pressed */
			&:focus-visible {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedSquare-color-label-focus));
			}

			@supports not selector(:focus-visible) {
				&:focus {
					border-top: var(--local-loader-border-idle) solid
						rgb(var(--button-extendedSquare-color-label-focus));
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					border-top: var(--local-loader-border-idle) solid
						rgb(var(--button-extendedSquare-color-label-hover));
				}
			}

			&:active {
				border-top: var(--local-loader-border-idle) solid rgb(var(--button-extendedSquare-color-label-pressed));
			}
		`,
    },
};
const bottomBorderStyles = `
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
`;
/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
const hoverAndFocusStyles = `
	outline: none;
	text-decoration: none;

	.${ImageRoot.base} {
		outline: var(--button-primary-border-focus) solid #fff;
	}
`;
export const Root = {
    base: css `
		&& {
			cursor: pointer;

			position: relative;

			float: left;
			overflow: hidden;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-items: center;

			box-sizing: border-box;
			margin: 0;
			padding: var(--button-base-spacing-padding-base-tb) var(--button-base-spacing-padding-base-lr);
			border-radius: var(--button-primary-corner-radius-all);

			color: rgb(var(--button-primary-color-label-idle));
			text-align: center;
			text-decoration: none;

			background: rgb(var(--button-primary-color-background-idle));
			outline: none;

			fill: rgb(var(--button-primary-color-icon-idle));

			-webkit-tap-highlight-color: transparent;

			/* Focus */
			&:focus-visible {
				${hoverAndFocusStyles};
				color: rgb(var(--button-primary-color-label-focus));
				background: rgb(var(--button-primary-color-background-focus));
				outline: var(--button-primary-border-focus) solid rgb(var(--button-primary-color-border-focus));
				fill: rgb(var(--button-primary-color-icon-focus));

				.${ImageRoot.base} {
					outline: none;
				}
			}

			@supports not selector(:focus-visible) {
				&:focus {
					${hoverAndFocusStyles};
					color: rgb(var(--button-primary-color-label-focus));
					background: rgb(var(--button-primary-color-background-focus));
					outline: var(--button-primary-border-focus) solid rgb(var(--button-primary-color-border-focus));
					fill: rgb(var(--button-primary-color-icon-focus));

					.${ImageRoot.base} {
						outline: none;
					}
				}
			}

			/* Hover */
			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					${hoverAndFocusStyles};
					color: rgb(var(--button-primary-color-label-hover));
					background: rgb(var(--button-primary-color-background-hover));
					fill: rgb(var(--button-primary-color-icon-hover));
				}
			}

			/* Pressed */
			&:active {
				${hoverAndFocusStyles};
				color: rgb(var(--button-primary-color-label-pressed));
				background: rgb(var(--button-primary-color-background-pressed));
				fill: rgb(var(--button-primary-color-icon-pressed));
			}

			span {
				display: flex;
				flex-grow: 1;
				align-items: center;

				height: var(--icon-sizing-icon-xs);
				padding: 0 var(--button-base-spacing-padding-label-lr);

				white-space: nowrap;

				outline: none;
			}

			.right {
				margin-left: auto;
			}

			svg,
			.${ImageRoot.base} {
				display: block;
				width: var(--icon-sizing-icon-xs);
				height: var(--icon-sizing-icon-xs);
			}

			/* Click animation */
			&:after {
				pointer-events: none;
				content: '';

				position: absolute;
				z-index: 1;
				top: 0;
				left: 0;
				transform: scale(10, 10);

				display: block;

				width: 100%;
				height: 100%;

				opacity: 0;
				/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
				background-image: radial-gradient(circle, #fff 10%, transparent 10.01%);
				background-repeat: no-repeat;
				background-position: 50%;

				transition:
					transform 400ms var(--global-ease-out),
					opacity 800ms;
			}

			&:active&:after {
				transform: scale(0, 0);
				opacity: 0.3;
				transition: 0ms;
			}
		}
	`,
    iconLeft: {
        base: css ``,
        type: {
            primary: null,
            secondary: null,
            square: null,
            text: null,
            chip: null,
            tab: null,
            live: null,
            function: css `
				&&& {
					span {
						padding-top: var(--button-base-spacing-gap-base);
					}
				}
			`,
            mini: null,
            textExt: null,
            squareExt: null,
        },
    },
    iconRight: {
        base: css ``,
        type: {
            primary: null,
            secondary: null,
            square: null,
            text: null,
            chip: null,
            tab: null,
            live: null,
            function: css `
				&& {
					span {
						padding-top: 0;
					}
				}
			`,
            mini: null,
            textExt: null,
            squareExt: null,
        },
    },
    isLoading: css `
		&& span {
			visibility: hidden;
		}
	`,
    isTruncated: css `
		&& {
			max-width: 100%;
			span {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	`,
    component: {
        button: css `
			border: 0;
		`,
    },
    isIconOnly: {
        base: css `
			height: fit-content;

			&&& {
				padding: 0;
				svg {
					padding: var(--button-base-spacing-padding-base-tb) var(--button-base-spacing-padding-base-lr);
				}

				.${ImageRoot.base} {
					width: calc(var(--icon-sizing-icon-xs) + (2 * var(--button-base-spacing-padding-base-tb)));
					height: calc(var(--icon-sizing-icon-xs) + (2 * var(--button-base-spacing-padding-base-tb)));
				}
			}

			.left,
			.right {
				display: flex;
				align-items: center;
				justify-content: center;

				width: 100%;
				margin: 0;
			}
		`,
        type: {
            primary: null,
            secondary: null,
            square: null,
            text: null,
            chip: null,
            tab: null,
            live: null,
            function: css `
				&&&&& {
					svg {
						padding: var(--button-function-spacing-padding-base);
					}

					.${ImageRoot.base} {
						width: calc(var(--icon-sizing-icon-s) + (2 * var(--button-function-spacing-padding-base)));
						height: calc(var(--icon-sizing-icon-s) + (2 * var(--button-function-spacing-padding-base)));
					}
				}
			`,
            mini: css `
				&&& {
					svg,
					.${ImageRoot.base} {
						width: var(--icon-sizing-icon-2xs);
						height: var(--icon-sizing-icon-2xs);
						padding: var(--button-mini-spacing-padding-tb) var(--button-mini-spacing-padding-lr);
					}
				}
			`,
            textExt: null,
            squareExt: css `
				&&& {
					width: auto;
					min-width: var(--button-extendedSquare-sizing-height-base);
					height: var(--button-extendedSquare-sizing-height-base);

					svg {
						width: var(--icon-sizing-icon-xl);
						height: var(--icon-sizing-icon-xl);
					}

					.${ImageRoot.base} {
						width: var(--button-extendedSquare-sizing-height-base);
						height: var(--button-extendedSquare-sizing-height-base);
					}
				}
			`,
        },
    },
    isIconOnlyMobile: css `
		${media('max', 's')} {
			padding: 0;
			span {
				display: none;
			}
		}
	`,
    type: {
        primary: null,
        secondary: css `
			&& {
				color: rgb(var(--button-secondary-color-label-idle));
				background: rgb(var(--button-secondary-color-background-idle-alpha));
				fill: rgb(var(--button-secondary-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-secondary-color-label-focus));
					background: rgb(var(--button-secondary-color-background-focus-alpha));
					outline: var(--button-secondary-border-focus) solid rgb(var(--button-secondary-color-border-focus));
					fill: rgb(var(--button-secondary-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-secondary-color-label-focus));
						background: rgb(var(--button-secondary-color-background-focus-alpha));
						outline: var(--button-secondary-border-focus) solid
							rgb(var(--button-secondary-color-border-focus));
						fill: rgb(var(--button-secondary-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-secondary-color-label-hover));
						background: rgb(var(--button-secondary-color-background-hover));
						fill: rgb(var(--button-secondary-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-secondary-color-label-pressed));
					background: rgb(var(--button-secondary-color-background-pressed));
					fill: rgb(var(--button-secondary-color-icon-pressed));
				}
			}
		`,
        chip: css `
			&& {
				padding: var(--button-chip-spacing-padding-tb) var(--button-base-spacing-padding-base-lr);
				color: rgb(var(--button-chip-color-label-idle));
				background: rgb(var(--button-chip-color-background-idle));
				fill: rgb(var(--button-chip-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-chip-color-label-focus));
					text-decoration-thickness: 1px;

					background: rgb(var(--button-chip-color-background-focus));
					outline: var(--button-chip-border-focus) solid rgb(var(--button-chip-color-border-focus));

					fill: rgb(var(--button-chip-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-chip-color-label-focus));
						text-decoration-thickness: 1px;

						background: rgb(var(--button-chip-color-background-focus));
						outline: var(--button-chip-border-focus) solid rgb(var(--button-chip-color-border-focus));

						fill: rgb(var(--button-chip-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-chip-color-label-hover));
						text-decoration-thickness: 1px;
						background: rgb(var(--button-chip-color-background-hover));
						fill: rgb(var(--button-chip-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-chip-color-label-pressed));
					text-decoration-thickness: 1px;
					background: rgb(var(--button-chip-color-background-pressed));
					fill: rgb(var(--button-chip-color-icon-pressed));
				}
			}
		`,
        square: css `
			&& {
				border-radius: var(--button-square-corner-radius-all);
				color: rgb(var(--button-square-color-label-idle));
				background: rgb(var(--button-square-color-background-idle));
				fill: rgb(var(--button-square-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-square-color-label-focus));
					background: rgb(var(--button-square-color-background-focus));
					outline: var(--button-square-border-focus) solid rgb(var(--button-square-color-border-focus));
					fill: rgb(var(--button-square-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-square-color-label-focus));
						background: rgb(var(--button-square-color-background-focus));
						outline: var(--button-square-border-focus) solid rgb(var(--button-square-color-border-focus));
						fill: rgb(var(--button-square-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-square-color-label-hover));
						background: rgb(var(--button-square-color-background-hover));
						fill: rgb(var(--button-square-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-square-color-label-pressed));
					background: rgb(var(--button-square-color-background-pressed));
					fill: rgb(var(--button-square-color-icon-pressed));
				}
			}
		`,
        text: css `
			&& {
				border-radius: var(--button-text-corner-radius-all);
				color: rgb(var(--button-text-color-label-idle));
				background: none;
				fill: rgb(var(--button-text-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-text-color-label-focus));
					background: none;
					outline: var(--button-text-border-focus) solid rgb(var(--button-text-color-border-focus));
					fill: rgb(var(--button-text-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-text-color-label-focus));
						background: none;
						outline: var(--button-text-border-focus) solid rgb(var(--button-text-color-border-focus));
						fill: rgb(var(--button-text-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-text-color-label-hover));
						background: none;
						fill: rgb(var(--button-text-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-text-color-label-pressed));
					background: none;
					fill: rgb(var(--button-text-color-icon-pressed));
				}
			}
		`,
        tab: css `
			&& {
				border-radius: var(--button-tab-corner-radius-top-lr) var(--button-tab-corner-radius-top-lr) 0 0;
				color: rgb(var(--button-tab-color-label-idle));
				background: rgb(var(--button-tab-color-background-idle-alpha));
				fill: rgb(var(--button-tab-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					border: none;

					color: rgb(var(--button-tab-color-label-focus));

					background: rgb(var(--button-tab-color-background-focus-alpha));
					outline: none;
					box-shadow: inset 0 0 0 var(--button-tab-border-focus) rgb(var(--button-tab-color-border-focus));

					fill: rgb(var(--button-tab-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						border: none;

						color: rgb(var(--button-tab-color-label-focus));

						background: rgb(var(--button-tab-color-background-focus-alpha));
						outline: none;
						box-shadow: inset 0 0 0 var(--button-tab-border-focus) rgb(var(--button-tab-color-border-focus));

						fill: rgb(var(--button-tab-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-tab-color-label-hover));
						background: rgb(var(--button-tab-color-background-hover));
						fill: rgb(var(--button-tab-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-tab-color-label-pressed));
					background: rgb(var(--button-tab-color-background-pressed));
					fill: rgb(var(--button-tab-color-icon-pressed));
				}
			}
		`,
        live: css `
			&& {
				color: rgb(var(--button-live-color-label-idle));
				background: rgb(var(--button-live-color-background-idle));
				fill: rgb(var(--button-live-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-live-color-label-focus));
					background: rgb(var(--button-live-color-background-focus));
					outline: var(--button-live-border-focus) solid rgb(var(--button-live-color-border-focus));
					fill: rgb(var(--button-live-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-live-color-label-focus));
						background: rgb(var(--button-live-color-background-focus));
						outline: var(--button-live-border-focus) solid rgb(var(--button-live-color-border-focus));
						fill: rgb(var(--button-live-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-live-color-label-hover));
						background: rgb(var(--button-live-color-background-hover));
						fill: rgb(var(--button-live-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-live-color-label-pressed));
					background: rgb(var(--button-live-color-background-pressed));
					fill: rgb(var(--button-live-color-icon-pressed));
				}
			}
		`,
        function: css `
			&& {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				padding: var(--button-function-spacing-padding-base);
				border-radius: var(--button-function-corner-radius-all);

				color: rgb(var(--button-function-color-label-idle));
				text-align: center;

				background: none;

				fill: rgb(var(--button-function-color-icon-idle));

				&& {
					svg,
					.${ImageRoot.base} {
						width: var(--icon-sizing-icon-s);
						height: var(--icon-sizing-icon-s);
					}
				}

				span {
					height: var(--icon-sizing-icon-s);
				}

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-function-color-label-focus));
					background: none;
					outline: var(--button-function-border-focus) solid rgb(var(--button-function-color-border-focus));
					fill: rgb(var(--button-function-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-function-color-label-focus));
						background: none;
						outline: var(--button-function-border-focus) solid
							rgb(var(--button-function-color-border-focus));
						fill: rgb(var(--button-function-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-function-color-label-hover));
						background: rgb(var(--button-function-color-background-hover));
						fill: rgb(var(--button-function-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-function-color-label-pressed));
					background: rgb(var(--button-function-color-background-pressed));
					fill: rgb(var(--button-function-color-icon-pressed));
				}
			}
		`,
        mini: css `
			&& {
				padding: var(--button-mini-spacing-padding-tb) var(--button-mini-spacing-padding-lr);
				color: rgb(var(--button-mini-color-label-idle));
				background: rgb(var(--button-mini-color-background-idle-alpha));
				fill: rgb(var(--button-mini-color-icon-idle));

				&& {
					svg,
					.${ImageRoot.base} {
						width: var(--icon-sizing-icon-2xs);
						height: var(--icon-sizing-icon-2xs);
					}
				}

				span {
					height: var(--icon-sizing-icon-2xs);
				}

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-mini-color-label-focus));
					text-decoration-thickness: 1px;

					background: rgb(var(--button-mini-color-background-focus-alpha));
					outline: var(--button-mini-border-focus) solid rgb(var(--button-mini-color-border-focus));

					fill: rgb(var(--button-mini-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-mini-color-label-focus));
						text-decoration-thickness: 1px;

						background: rgb(var(--button-mini-color-background-focus-alpha));
						outline: var(--button-mini-border-focus) solid rgb(var(--button-mini-color-border-focus));

						fill: rgb(var(--button-mini-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-mini-color-label-hover));
						text-decoration-thickness: 1px;
						background: rgb(var(--button-mini-color-background-hover));
						fill: rgb(var(--button-mini-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-mini-color-label-pressed));
					text-decoration-thickness: 1px;
					background: rgb(var(--button-mini-color-background-pressed));
					fill: rgb(var(--button-mini-color-icon-pressed));
				}
			}
		`,
        textExt: css `
			&& {
				border-radius: initial;
				color: rgb(var(--button-extendedText-color-label-idle));
				background: none;
				fill: rgb(var(--button-extendedText-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					border-radius: var(--button-extendedText-corner-radius-all);

					color: rgb(var(--button-extendedText-color-label-focus));

					background: none;
					outline: var(--button-extendedText-border-focus) solid
						rgb(var(--button-extendedText-color-border-focus));

					fill: rgb(var(--button-extendedText-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						border-radius: var(--button-extendedText-corner-radius-all);

						color: rgb(var(--button-extendedText-color-label-focus));

						background: none;
						outline: var(--button-extendedText-border-focus) solid
							rgb(var(--button-extendedText-color-border-focus));

						fill: rgb(var(--button-extendedText-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						border-radius: var(--button-extendedText-corner-radius-all);
						color: rgb(var(--button-extendedText-color-label-hover));
						background: rgb(var(--button-extendedText-color-background-hover));
						fill: rgb(var(--button-extendedText-color-icon-hover));
					}
				}

				&:active {
					border-radius: var(--button-extendedText-corner-radius-all);
					color: rgb(var(--button-extendedText-color-label-pressed));
					background: rgb(var(--button-extendedText-color-background-pressed));
					fill: rgb(var(--button-extendedText-color-icon-pressed));
				}
			}
		`,
        squareExt: css `
			&& {
				width: var(--button-extendedSquare-sizing-width-base);
				height: var(--button-extendedSquare-sizing-height-base);
				padding: var(--button-extendedSquare-spacing-padding-base);
				border-radius: var(--button-extendedSquare-corner-radius-all);

				color: rgb(var(--button-extendedSquare-color-label-idle));

				background: rgb(var(--button-extendedSquare-color-background-idle-alpha));

				fill: rgb(var(--button-extendedSquare-color-icon-idle));

				span {
					overflow: hidden;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;

					height: auto;

					text-align: center;
					text-overflow: ellipsis;
					white-space: normal;
				}

				/* Hover / Focus / Pressed */
				&:focus-visible {
					color: rgb(var(--button-extendedSquare-color-label-focus));
					background: rgb(var(--button-extendedSquare-color-background-focus-alpha));
					outline: var(--button-extendedSquare-border-focus) solid
						rgb(var(--button-extendedSquare-color-border-focus));
					fill: rgb(var(--button-extendedSquare-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						color: rgb(var(--button-extendedSquare-color-label-focus));
						background: rgb(var(--button-extendedSquare-color-background-focus-alpha));
						outline: var(--button-extendedSquare-border-focus) solid
							rgb(var(--button-extendedSquare-color-border-focus));
						fill: rgb(var(--button-extendedSquare-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						color: rgb(var(--button-extendedSquare-color-label-hover));
						background: rgb(var(--button-extendedSquare-color-background-hover-alpha));
						fill: rgb(var(--button-extendedSquare-color-icon-hover));
					}
				}

				&:active {
					color: rgb(var(--button-extendedSquare-color-label-pressed));
					background: rgb(var(--button-extendedSquare-color-background-pressed-alpha));
					fill: rgb(var(--button-extendedSquare-color-icon-pressed));
				}
			}
		`,
    },
    disabled: {
        base: css `
			&& {
				pointer-events: none;
				opacity: 0.5;
			}
		`,
        icon: css `
			${iconDisabledStyles};
		`,
        type: {
            primary: css `
				&& {
					color: rgb(var(--button-primary-color-label-disabled-alpha));
					background: rgb(var(--button-primary-color-background-disabled-alpha));
					fill: rgb(var(--button-primary-color-icon-disabled-alpha));
				}
			`,
            secondary: css `
				&& {
					color: rgb(var(--button-secondary-color-label-disabled-alpha));
					background: rgb(var(--button-secondary-color-background-disabled-alpha));
					fill: rgb(var(--button-secondary-color-icon-disabled-alpha));
				}
			`,
            square: css `
				&& {
					color: rgb(var(--button-square-color-label-disabled-alpha));
					background: rgb(var(--button-square-color-background-disabled-alpha));
					fill: rgb(var(--button-square-color-icon-disabled-alpha));
				}
			`,
            text: css `
				&& {
					color: rgb(var(--button-text-color-label-disabled-alpha));
					background: none;
					fill: rgb(var(--button-text-color-icon-disabled-alpha));
				}
			`,
            textExt: css `
				&& {
					color: rgb(var(--button-extendedText-color-label-disabled-alpha));
					background: rgb(var(--button-extendedText-color-background-disabled-alpha));
					fill: rgb(var(--button-extendedText-color-icon-disabled-alpha));
				}
			`,
            chip: css `
				&& {
					color: rgb(var(--button-chip-color-label-disabled-alpha));
					background: rgb(var(--button-chip-color-background-disabled-alpha));
					fill: rgb(var(--button-chip-color-icon-disabled-alpha));
				}
			`,
            tab: css `
				&&& {
					border-color: rgb(var(--button-tab-color-border-disabled-alpha));
					color: rgb(var(--button-tab-color-label-disabled-alpha));
					background: rgb(var(--button-tab-color-background-disabled-alpha));
					fill: rgb(var(--button-tab-color-icon-disabled-alpha));
				}
			`,
            live: css `
				&& {
					color: rgb(var(--button-live-color-label-disabled-alpha));
					background: rgb(var(--button-live-color-background-disabled-alpha));
					fill: rgb(var(--button-live-color-icon-disabled-alpha));
				}
			`,
            function: css `
				&&& {
					color: rgb(var(--button-function-color-label-disabled-alpha));
					background: rgb(var(--button-function-color-background-disabled-alpha));
					fill: rgb(var(--button-function-color-icon-disabled-alpha));
				}
			`,
            mini: css `
				&& {
					color: rgb(var(--button-mini-color-label-disabled-alpha));
					background: rgb(var(--button-mini-color-background-disabled-alpha));
					fill: rgb(var(--button-mini-color-icon-disabled-alpha));
				}
			`,
            squareExt: css `
				&& {
					color: rgb(var(--button-extendedSquare-color-label-disabled-alpha));
					background: rgb(var(--button-extendedSquare-color-background-disabled-alpha));
					fill: rgb(var(--button-extendedSquare-color-icon-disabled-alpha));
				}
			`,
        },
    },
    alignment: {
        right: css `
			justify-content: flex-end;
		`,
        left: null,
    },
    activeType: {
        base: css `
			&& {
				color: rgb(var(--button-primary-color-label-active));

				background: rgb(var(--button-primary-color-background-active));
				outline: none;
				box-shadow: none;

				fill: rgb(var(--button-primary-color-icon-active));

				&:focus-visible {
					&:before {
						border: none;
					}
				}

				@supports not selector(:focus-visible) {
					&:focus {
						&:before {
							border: none;
						}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						&:before {
							border: none;
						}
					}
				}

				.${Loader.base} {
					border-top: var(--button-primary-border-active) solid rgb(var(--button-primary-color-label-active));
				}
			}
		`,
        type: {
            primary: null,
            secondary: css `
				&& {
					color: rgb(var(--button-secondary-color-label-active));
					background: rgb(var(--button-secondary-color-background-active));
					fill: rgb(var(--button-secondary-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-secondary-border-active) solid
							rgb(var(--button-secondary-color-label-active));
					}
				}
			`,
            square: css `
				&& {
					color: rgb(var(--button-square-color-label-active));
					background: rgb(var(--button-square-color-background-active));
					fill: rgb(var(--button-square-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-square-border-active) solid
							rgb(var(--button-square-color-label-active));
					}
				}
			`,
            text: css `
				&& {
					color: rgb(var(--button-text-color-label-active));
					background: none;
					fill: rgb(var(--button-text-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-text-border-active) solid rgb(var(--button-text-color-label-active));
					}
				}
			`,
            tab: css `
				&& {
					color: rgb(var(--button-tab-color-label-active));
					background: none;
					fill: rgb(var(--button-tab-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-tab-border-active) solid rgb(var(--button-tab-color-label-active));
					}

					&:before {
						${bottomBorderStyles};
						border-bottom: var(--button-tab-border-active) solid rgb(var(--button-tab-color-border-active));
					}
				}
			`,
            chip: css `
				&& {
					color: rgb(var(--button-chip-color-label-active));
					background: rgb(var(--button-chip-color-background-active));
					fill: rgb(var(--button-chip-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-chip-border-active) solid rgb(var(--button-chip-color-label-active));
					}
				}
			`,
            live: css `
				&& {
					color: rgb(var(--button-live-color-label-active));
					background: rgb(var(--button-live-color-background-active));
					fill: rgb(var(--button-live-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-live-border-active) solid rgb(var(--button-live-color-label-active));
					}
				}
			`,
            function: css `
				&&& {
					color: rgb(var(--button-function-color-label-active));
					background: rgb(var(--button-function-color-background-active));
					fill: rgb(var(--button-function-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-function-border-active) solid
							rgb(var(--button-function-color-label-active));
					}
				}
			`,
            mini: css `
				&& {
					color: rgb(var(--button-mini-color-label-active));
					background: rgb(var(--button-mini-color-background-active));
					fill: rgb(var(--button-mini-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-mini-border-active) solid rgb(var(--button-mini-color-label-active));
					}
				}
			`,
            textExt: css `
				&& {
					border-radius: initial;
					color: rgb(var(--button-extendedText-color-label-active));
					background: none;
					fill: rgb(var(--button-extendedText-color-icon-active));

					.${Loader.base} {
						border-top: var(--button-extendedText-border-active) solid
							rgb(var(--button-extendedText-color-label-active));
					}

					&:before {
						${bottomBorderStyles};
						border-bottom: var(--button-extendedText-border-active) solid
							rgb(var(--button-extendedText-color-border-active));
					}

					&:active {
						border-bottom: none;
					}
				}
			`,
            squareExt: css `
				&& {
					color: rgb(var(--button-extendedSquare-color-label-active));
					background: rgb(var(--button-extendedSquare-color-background-active));
					fill: rgb(var(--button-extendedSquare-color-icon-active));
				}
			`,
        },
    },
};
export const ToggleIcon = {
    base: css `
		position: absolute;
	`,
};
export const IconAnimation = {
    base: css `
		transform: rotate(0deg) scale(1);
		opacity: 1;
		transition: 100ms var(--global-ease-out) all;
		transition-delay: 50ms;
	`,
    isToggled: css `
		&& {
			transform: rotate(180deg) scale(0.7);
			opacity: 0;
			transition: 100ms var(--global-ease-in) all;
			transition-delay: 0ms;
		}
	`,
};
export const IconToggleAnimation = {
    base: css `
		transform: rotate(-180deg) scale(0.7);
		opacity: 0;
		transition: 100ms var(--global-ease-in) all;
		transition-delay: 0ms;
	`,
    isToggled: css `
		&& {
			transform: rotate(0deg) scale(1);
			opacity: 1;
			transition: 100ms var(--global-ease-out) all;
			transition-delay: 50ms;
		}
	`,
};
export const IconWrapper = {
    base: css ``,
    hover: css `
		${iconHoverFocusStyles};
	`,
    isLoading: css `
		visibility: hidden;
	`,
    isNotIconOnly: {
        base: css `
			display: flex;
			flex-direction: column;
			justify-content: center;

			&& {
				.${ImageRoot.base} {
					box-sizing: border-box;
					width: var(--icon-sizing-icon-xs);
					height: var(--icon-sizing-icon-xs);
					padding: 0;

					background: transparent;

					transition: all 50ms;
				}
			}
		`,
        type: {
            primary: null,
            secondary: null,
            square: null,
            text: null,
            chip: null,
            tab: null,
            live: null,
            function: null,
            mini: null,
            textExt: null,
            squareExt: null,
        },
    },
    type: {
        primary: null,
        secondary: null,
        square: null,
        text: null,
        chip: null,
        tab: null,
        live: null,
        function: null,
        mini: null,
        textExt: null,
        squareExt: null,
    },
};
/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
export const childBgPattern = (backgroundIdleVar, borderIdleVar, shadowBaseVar) => `
  background-image: linear-gradient(
    180deg,
    rgb(var(${backgroundIdleVar}), 1) 0%,
    rgb(var(${backgroundIdleVar}), 0) 80%
  ),
  repeating-linear-gradient(
    45deg,
    rgb(120, 120, 120, 0.2),
    rgb(120, 120, 120, 0.2) 1.4rem,
    transparent 1.4rem,
    transparent 2.8rem
  );

  box-shadow: inset 0 0 0 2px rgb(var(${borderIdleVar}), 1);
  border-color: rgb(var(${shadowBaseVar}), 1);
`;
const childShadowBottom = `
	border-style: solid;
	border-radius: var(--button-primary-corner-radius-all);
	border-width: 2px;
	border-top-width: 0;
	border-left-width: 0;
	border-right-width: 0;
`;
export const Child = {
    base: css `
		&& {
			${childShadowBottom};

			/* Hover / Focus / Pressed */
			&:focus-visible {
				outline: none;
			}

			@supports not selector(:focus-visible) {
				&:focus {
					outline: none;
				}
			}

			&:hover {
				@media (any-hover: hover), (any-pointer: fine) {
					.${ImageRoot.base} {
						outline: none;
					}
				}
			}

			&:active {
				.${ImageRoot.base} {
					outline: none;
				}
			}
		}
	`,
    type: {
        primary: css `
			&& {
				${childBgPattern('--button-primary-color-background-idle', '--button-primary-color-border-idle', '--button-primary-shadow-base')}

				/* Hover / Focus / Pressed */
  		&:focus-visible {
					${childBgPattern('--button-primary-color-background-focus', '--button-primary-color-border-focus', '--button-primary-shadow-base')}
				}

				@supports not selector(:focus-visible) {
					&:focus {
						${childBgPattern('--button-primary-color-background-focus', '--button-primary-color-border-focus', '--button-primary-shadow-base')}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						${childBgPattern('--button-primary-color-background-hover', '--button-primary-color-border-hover', '--button-primary-shadow-base')}
					}
				}

				&:active {
					${childBgPattern('--button-primary-color-background-pressed', '--button-primary-color-border-pressed', '--button-primary-shadow-base')}
				}

				${iconIdlePrimaryStyles};
			}
		`,
        secondary: css `
			&& {
				border-color: rgb(var(--button-secondary-shadow-base));
				background-image: none;
				box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-hover));
					}
				}

				&:active {
					background: rgb(var(--button-secondary-color-background-pressed));
					box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-pressed));
				}
			}
		`,
        square: css `
			&& {
				border: none;
				border-radius: var(--button-square-corner-radius-all);

				color: rgb(var(--button-square-color-label-idle));

				background: rgb(var(--button-square-color-background-idle));
				box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-idle));

				fill: rgb(var(--button-square-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-hover));
					}
				}

				&:active {
					background: rgb(var(--button-square-color-background-pressed));
					box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-pressed));
				}
			}
		`,
        text: css `
			&& {
				border: none;
				border-radius: var(--button-text-corner-radius-all);
				background-image: none;
				box-shadow: none;

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-text-color-border-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-text-color-border-focus));
					}
				}

				&:active {
					color: rgb(var(--button-text-color-label-pressed));
				}
			}
		`,
        chip: css `
			&& {
				border-color: rgb(var(--button-chip-shadow-base));
				background-image: none;
				box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-hover));
					}
				}

				&:active {
					background: rgb(var(--button-chip-color-background-pressed));
					box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-pressed));
				}
			}
		`,
        tab: css `
			&& {
				border: none;
				border-radius: var(--button-tab-corner-radius-top-lr) var(--button-tab-corner-radius-top-lr) 0 0;
				box-shadow: none;

				&:before {
					${bottomBorderStyles};
					border-bottom: var(--button-tab-border-focus) solid rgb(var(--button-tab-color-border-idle));
				}

				/* Hover / Focus / Pressed */
				&:focus-visible {
					border: none;
					box-shadow: none;

					&:before {
						border: none;
					}
				}

				@supports not selector(:focus-visible) {
					&:focus {
						border: none;
						box-shadow: none;

						&:before {
							border: none;
						}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						border-color: rgb(var(--button-tab-color-border-hover));

						&:before {
							border: none;
						}
					}
				}

				&:active {
					&:before {
						${bottomBorderStyles};
						border-bottom: var(--button-tab-border-focus) solid rgb(var(--button-tab-color-border-pressed));
					}
				}
			}
		`,
        live: css `
			&& {
				${childBgPattern('--button-live-color-background-idle', '--button-live-color-border-idle', '--button-live-shadow-base')}

				/* Hover / Focus / Pressed */
  		&:focus-visible {
					${childBgPattern('--button-live-color-background-focus', '--button-live-color-border-focus', '--button-live-shadow-base')}
				}

				@supports not selector(:focus-visible) {
					&:focus {
						${childBgPattern('--button-live-color-background-focus', '--button-live-color-border-focus', '--button-live-shadow-base')}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						${childBgPattern('--button-live-color-background-hover', '--button-live-color-border-hover', '--button-live-shadow-base')}
					}
				}

				&:active {
					${childBgPattern('--button-live-color-background-pressed', '--button-live-color-border-pressed', '--button-live-shadow-base')}
				}
			}
		`,
        function: css `
			&& {
				border: none;
				border-radius: var(--button-function-corner-radius-all);

				background: none;
				box-shadow: none;

				fill: rgb(var(--button-function-color-icon-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-function-color-border-focus));
					fill: rgb(var(--button-function-color-icon-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-function-color-border-focus));
						fill: rgb(var(--button-function-color-icon-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						fill: rgb(var(--button-function-color-icon-hover));
					}
				}

				&:active {
					background: rgb(var(--button-function-color-background-pressed));
				}
			}
		`,
        mini: css `
			&& {
				border-color: rgb(var(--button-mini-shadow-base));
				background-image: none;
				box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-idle));

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-focus));
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-focus));
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-hover));
					}
				}

				&:active {
					background: rgb(var(--button-mini-color-background-pressed));
					box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-pressed));
				}
			}
		`,
        textExt: css `
			&& {
				border: none;
				border-radius: var(--button-extendedText-corner-radius-all);
				background-image: none;
				box-shadow: none;

				/* Hover / Focus / Pressed */
				&:focus-visible {
					box-shadow: inset 0 0 0 2px rgb(var(--button-extendedText-color-border-focus));
					&:before {
						border: none;
					}
				}

				@supports not selector(:focus-visible) {
					&:focus {
						box-shadow: inset 0 0 0 2px rgb(var(--button-extendedText-color-border-focus));
						&:before {
							border: none;
						}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						box-shadow: none;
						&:before {
							border: none;
						}
					}
				}

				&:active {
					color: rgb(var(--button-extendedText-color-label-pressed));
					background: rgb(var(--button-extendedText-color-background-pressed));
					fill: rgb(var(--button-extendedText-color-icon-pressed));
				}
			}
		`,
        squareExt: css `
			&& {
				border: none;
				border-radius: var(--button-extendedSquare-corner-radius-all);
			}
		`,
    },
    activeType: {
        base: css `
			&& {
				box-shadow: inset 0 0 0 2px rgb(var(--button-primary-color-border-active));

				&:hover {
					&[data-type='primary'],
					&[data-type='live'],
					&[data-type='mini'],
					&[data-type='chip'] {
						@media (any-hover: hover), (any-pointer: fine) {
							${childShadowBottom};
						}
					}
				}
			}
		`,
        type: {
            primary: null,
            secondary: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-active));
				}
			`,
            square: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-active));
				}
			`,
            text: css `
				&& {
					border: none;

					color: rgb(var(--button-text-color-label-active));

					background: none;
					box-shadow: none;

					fill: rgb(var(--button-text-color-icon-active));
				}
			`,
            chip: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-active));
				}
			`,
            tab: css `
				&& {
					border-bottom: none;

					color: rgb(var(--button-tab-color-label-active));

					background: rgb(var(--button-tab-color-background-active));
					box-shadow: none;

					fill: rgb(var(--button-tab-color-icon-active));
				}
			`,
            live: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-live-color-border-active));
				}
			`,
            function: css `
				&& {
					border: none;

					color: rgb(var(--button-function-color-label-active));

					background: rgb(var(--button-function-color-background-active));
					box-shadow: none;

					fill: rgb(var(--button-function-color-label-active));
				}
			`,
            mini: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-active));
				}
			`,
            textExt: css `
				&& {
					border-radius: initial;

					color: rgb(var(--button-extendedText-color-label-active));

					background: none;
					box-shadow: none;

					fill: rgb(var(--button-extendedText-color-icon-active));

					${iconIdlePrimaryStyles};

					&:before {
						${bottomBorderStyles};
						border-bottom: var(--button-extendedText-border-active) solid
							rgb(var(--button-extendedText-color-border-active));
					}
				}
			`,
            squareExt: css `
				&& {
					box-shadow: inset 0 0 0 2px rgb(var(--button-extendedSquare-color-border-active));
				}
			`,
        },
    },
    disabled: {
        base: css `
			&& {
				border: none;
				background: rgb(var(--button-primary-color-background-disabled-alpha));
				box-shadow: inset 0 0 0 2px rgb(var(--button-primary-color-border-disabled-alpha));

				&:before {
					border: none;
				}
			}
		`,
        type: {
            primary: null,
            secondary: css `
				&& {
					border: none;
					background: rgb(var(--button-secondary-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-secondary-color-border-disabled-alpha));
				}
			`,
            square: css `
				&& {
					border: none;
					background: rgb(var(--button-square-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-square-color-border-disabled-alpha));
				}
			`,
            text: css `
				&& {
					color: rgb(var(--button-text-color-label-disabled-alpha));
					background: none;
					box-shadow: none;
				}
			`,
            chip: css `
				&& {
					${childShadowBottom};
					border-color: rgb(var(--button-chip-shadow-base));
					background: rgb(var(--button-chip-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-chip-color-border-disabled-alpha));
				}
			`,
            tab: css `
				&& {
					border: none;
					background: rgb(var(--button-tab-color-background-disabled-alpha));
					box-shadow: none;
				}
			`,
            live: css `
				&& {
					border: none;
					background: rgb(var(--button-live-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-live-color-border-disabled-alpha));
				}
			`,
            function: css `
				&& {
					border: none;
					color: rgb(var(--button-function-color-label-disabled-alpha));
					background: rgb(var(--button-function-color-background-disabled-alpha));
					fill: rgb(var(--button-function-color-label-disabled-alpha));
				}
			`,
            mini: css `
				&& {
					border: none;
					background: rgb(var(--button-mini-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-mini-color-border-disabled-alpha));
				}
			`,
            textExt: css `
				&& {
					color: rgb(var(--button-extendedText-color-label-disabled-alpha));
					background: none;
					box-shadow: none;
				}
			`,
            squareExt: css `
				&& {
					border: none;
					background: rgb(var(--button-extendedSquare-color-background-disabled-alpha));
					box-shadow: inset 0 0 0 2px rgb(var(--button-extendedSquare-color-border-disabled-alpha));
				}
			`,
        },
    },
    isIconOnly: {
        base: null,
        type: {
            primary: null,
            secondary: null,
            square: null,
            text: null,
            chip: null,
            tab: null,
            live: null,
            function: null,
            mini: null,
            textExt: null,
            squareExt: null,
        },
    },
};
